module.exports = __webpack_public_path__ + "static/media/expand-arrows.ea56030b.svg";